import { white, black } from '../common/colors';

export default {
  common: {
    black,
    white,
    neutral: '#E4E7EB',
    muted: '#9EA0A4',
    principal: '#328AA4'
  },
  primary: {
    contrastText: white,
    main: '#328AA4',
    light: '#F6F9FD',
    dark: '#848688',
  },
  secondary: {
    contrastText: white,
    main: '#DF0101',
    light: '#F5A9A9',
    dark: '#610B0B'
  },
  success: {
    contrastText: white,
    main: '#45B880',
    light: '#F1FAF5',
    dark: '#00783E'
  },
  info: {
    contrastText: white,
    main: '#1070CA',
    light: '#F1FBFC',
    dark: '#007489'
  },
  warning: {
    contrastText: white,
    main: '#FFB822',
    light: '#FDF8F3',
    dark: '#95591E'
  },
  danger: {
    contrastText: white,
    main: '#ED4740',
    light: '#FEF6F6',
    dark: '#BF0E08'
  },
  text: {
    primary: '#12161B',
    secondary: '#66788A',
    disabled: '#66788A',
    white: '#F1FBFC'
  },
  background: {
    default: '#f8fafc',
    //dark: '#172B4D',
    dark: '#999',
    paper: white
  },
  border: '#DFE3E8',
  divider: '#DFE3E8'
};